import { Sidebar } from '../Sidebar';

// Moldura de toda tela logada: sidebar em card à esquerda e o conteúdo num card branco
// grande, com cabeçalho (ícone + rótulo pequeno, título, ações à direita e uma linha de
// status acima das ações, ex. "Atualizado às 14:02").
export const AppShell = ({ icon: Icon, title, eyebrow, meta, actions, children }) => (
  <div className="min-h-screen bg-canvas lg:flex lg:gap-4 lg:p-4">
    <Sidebar />
    <main className="min-w-0 flex-1 bg-white lg:rounded-2xl lg:border lg:border-gray-200/70 lg:shadow-card">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-5 sm:px-6 lg:px-7 lg:py-6">
        <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div className="min-w-0">
            <div className="mb-1.5 flex items-center gap-2 text-[13px] text-gray-500">
              {Icon && <Icon className="h-4 w-4" />}
              <span>{eyebrow || title}</span>
            </div>
            <h1 className="truncate text-2xl font-semibold tracking-tight text-gray-900">{title}</h1>
          </div>
          {(actions || meta) && (
            <div className="flex flex-col gap-2 sm:items-end">
              {meta && <p className="text-xs text-gray-500">{meta}</p>}
              {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
            </div>
          )}
        </div>
        {children}
      </div>
    </main>
  </div>
);

// Botões do cabeçalho (Exportar / Atualizar / ação principal)
export const headerButtonClass =
  'inline-flex items-center justify-center gap-2 rounded-xl border border-gray-200 bg-white px-3.5 py-2 text-sm font-medium text-gray-700 shadow-card transition hover:bg-gray-50 disabled:opacity-50';
export const headerPrimaryButtonClass =
  'inline-flex items-center justify-center gap-2 rounded-xl bg-accent px-4 py-2 text-sm font-medium text-white shadow-sm shadow-accent/25 transition hover:bg-accent-hover disabled:opacity-60';
